import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { systemMetadata } from '@mysidewalk/references';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle as faCircleEmpty } from '@fortawesome/pro-regular-svg-icons';
import {
  faCircle,
  faCircleHalfStroke,
} from '@fortawesome/pro-solid-svg-icons';

const { FeatureClass } = systemMetadata;

const AvailabilityStatusType = {
  FULL: 'FULL',
  MAJORITY: 'MAJORITY',
  PARTIAL: 'PARTIAL',
  LOW: 'LOW',
  NONE: 'NONE',
};

const ICON_MAP = {
  [AvailabilityStatusType.FULL]: faCircle,
  [AvailabilityStatusType.MAJORITY]: faCircle,
  [AvailabilityStatusType.PARTIAL]: faCircleHalfStroke,
  [AvailabilityStatusType.LOW]: faCircleHalfStroke,
  [AvailabilityStatusType.NONE]: faCircleEmpty,
};

const COLOR_MAP = {
  [AvailabilityStatusType.FULL]: 'var(--green-500)',
  [AvailabilityStatusType.MAJORITY]: 'var(--accessible-green)',
  [AvailabilityStatusType.PARTIAL]: 'var(--yellow-500)',
  [AvailabilityStatusType.LOW]: 'var(--yellow-500)',
  [AvailabilityStatusType.NONE]: 'var(--black)',
};

const OPACITY_MAP = {
  [AvailabilityStatusType.FULL]: '1',
  [AvailabilityStatusType.MAJORITY]: '1',
  [AvailabilityStatusType.PARTIAL]: '1',
  [AvailabilityStatusType.LOW]: '1',
  [AvailabilityStatusType.NONE]: '0.5',
};

function statusTypeForAvailability(availability) {
  if (availability === 0.99) {
    return AvailabilityStatusType.FULL;
  } if (availability > 0.65) {
    return AvailabilityStatusType.MAJORITY;
  } if (availability > 0.45) {
    return AvailabilityStatusType.PARTIAL;
  } if (availability > 0) {
    return AvailabilityStatusType.LOW;
  }
  return AvailabilityStatusType.NONE;
}

function FeatureClassAvailability({
  available,
}) {
  // Use "100%" coverage for all feature classes until the API is more specific
  const availableByID = available.reduce((memo, id) => {
    const copyMemo = memo;
    copyMemo[id] = 1;
    return copyMemo;
  }, {});

  const [featureClasses, setFeatureClasses] = useState([]);
  useEffect(() => {
    if (featureClasses.length === 0) {
      FeatureClass.all().then(setFeatureClasses);
    }
  }, [featureClasses]);

  const classes = featureClasses.map((featureClass) => {
    const statusType = statusTypeForAvailability(availableByID[featureClass.id]);
    const icon = ICON_MAP[statusType];
    const color = COLOR_MAP[statusType];
    const opacity = OPACITY_MAP[statusType];
    return (
      <li
        key={featureClass.id}
        className="feature-class-availability__class"
        style={{ opacity }}
      >
        <span className="feature-class-availability__class-icon">
          <FontAwesomeIcon icon={icon} style={{ color }} />
        </span>
        <span className="feature-class-availability__class-label">
          {featureClass.pluralLongName}
        </span>
      </li>
    );
  });

  return (
    <figure>
      <ul className="feature-class-availability">
        {classes}
      </ul>
    </figure>
  );
}

FeatureClassAvailability.propTypes = {
  available: PropTypes.arrayOf(PropTypes.shape),
};

FeatureClassAvailability.defaultProps = {
  available: null,
};

export default FeatureClassAvailability;
